import React, { Component } from "react";
import { AnimatedView, BasicForms } from "../../../components";
import { FormGroup, FormControl, ControlLabel, Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import CountryStateCity from "../../../components/countryStateCity/CountryStateCity";
import Panel from "../../../components/panel/Panel";
import cx from "classnames";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";

import NumberFormat from "react-number-format";

let userResponse = "";
let emailResponse = "";
let invalidphone = "";
let invalidemail = "";
class StepTwo extends Component {
  static propTypes = {
    userNameOnChange: PropTypes.func,
    emailOnChange: PropTypes.func,
    siteDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  };

  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      email: "",
      firstName: "",
      lastName: "",
      dob: "",
      gender: "Male",
      phone: "",
      address1: "",
      address2: "",
      zipcode: "",
      password: "",
      userStatus: "active",
      countryName: "",
      country: "",
      state: "",
      city: "",
      cityId: "",
      errors: [],
      stateAbbr: "",
      id: "",
      countryerror: "",
      stateerror: "",
      cityerror: "",
      alertMessage: "",
      alert: false,
    };
    this.validate = this.validate.bind(this);
    this.handlesOnChanged = this.handlesOnChanged.bind(this);
    this.handlesOnEmailChanged = this.handlesOnEmailChanged.bind(this);
    this.handlesOnPhoneChanged = this.handlesOnPhoneChanged.bind(this);
    this.handlesOnUserChanged = this.handlesOnUserChanged.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.previousStep = this.previousStep.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  validate = () => {
    let emilpattern = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i);
    let mobilepattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);
    let isError = false;
    const errors = {};
    if (this.state.userName.length === 0) {
      isError = true;
      this.setState({ userNameError: "red" });
    } else {
      isError = false;
    }

    if (this.state.email.length === 0) {
      isError = true;
      this.setState({ emailError: "red" });
    } else {
      isError = false;
    }

    if (this.state.firstName.length === 0) {
      isError = true;
      this.setState({ firstNameError: "red" });
    } else {
      isError = false;
    }

    if (this.state.lastName.length === 0) {
      isError = true;
      this.setState({ lastNameError: "red" });
    } else {
      isError = false;
    }

    if (this.state.address1.length === 0) {
      isError = true;
      this.setState({ address1Error: "red" });
    } else {
      isError = false;
    }

    if (this.state.address1.length === 0) {
      isError = true;
      this.setState({ address1Error: "red" });
    } else {
      isError = false;
    }

    if (this.state.email) {
      if (!emilpattern.test(this.state.email)) {
        isError = true;
        this.setState({ emailError: "red" });
      }
    }

    if (this.state.phone) {
      if (!mobilepattern.test(this.state.phone)) {
        isError = true;
        this.setState({ phoneError: "red" });
      }
    }

    if (this.state.country.length === 0) {
      isError = true;
      this.setState({ countryerror: "true" });
    }

    if (this.state.state.length === 0) {
      isError = true;
      this.setState({ stateerror: "true" });
    }
    if (this.state.city.length === 0) {
      isError = true;
      this.setState({ cityerror: "true" });
    }
    return isError;
  };

  componentWillMount() {
    const rehydrate = JSON.parse(localStorage.getItem("addNewSiteSavedState"));
    this.setState(rehydrate);

   // console.log(this.props.siteDetails);
    if (this.props.siteDetails.siteID) {
      this.setState({
        id: this.props.siteDetails.userid,
        userName: this.props.siteDetails.userName,
        email: this.props.siteDetails.email,
        firstName: this.props.siteDetails.firstName,
        lastName: this.props.siteDetails.lastName,
        dob: this.props.siteDetails.dob,
        gender: this.props.siteDetails.gender,
        phone: this.props.siteDetails.phone,
        address1: this.props.siteDetails.address1,
        address2: this.props.siteDetails.address2,
        zipcode: this.props.siteDetails.zipcode
          ? this.props.siteDetails.zipcode
          : "",
        countryName: this.props.siteDetails.userCountry,
        country: this.props.siteDetails.country,
        state: this.props.siteDetails.userState,
        stateAbbr: this.props.siteDetails.stateAbbr,
        city: this.props.siteDetails.city,
        cityId: this.props.siteDetails.cityID,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.messageResponse) {
      userResponse = nextProps.messageResponse.response;
      if (userResponse == "error") {
        this.setState({ alert: true });
        this.setState({
          alertMessage: "The user name has already been taken.",
          msgType: "warning",
        });
        this.setState({ userName: "" });
      }
    }

    if (nextProps.emailResponse) {
      emailResponse = nextProps.emailResponse.response;
      if (emailResponse == "error") {
        alert("The email address has already been taken.");
        this.setState({ email: "" });
      }
    }
  }

  componentWillUnmount() {
    localStorage.setItem("addNewSiteSavedState", JSON.stringify(this.state));
  }

  handlesOnChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  handlesOnUserChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ userName: e.target.value });
  }

  onUserNameBlur = (field) => (e) => {
    e.preventDefault();
    this.props.userNameOnChange(this.state.userName);
  };

  onEmailBlur = (field) => (e) => {
    e.preventDefault();
    this.props.emailOnChange(this.state.email);
  };

  handleDismiss() {
    this.setState({ alert: false });
  }

  handleShow() {
    this.setState({ alert: true });
  }

  handlesOnEmailChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ email: e.target.value });
    let pattern = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (!pattern.test(e.target.value)) {
      this.setState({ emailError: "red" });
    } else {
      this.setState({ emailError: "" });
    }
  }

  handlesOnPhoneChanged(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ phone: e.target.value });
    let pattern = new RegExp(/^\d{3}-\d{3}-\d{4}$/i);

    if (!pattern.test(e.target.value)) {
      if (e.target.value.length > 0) {
        this.setState({ phoneError: "red" });
      }
    } else {
      this.setState({ phoneError: "" });
    }
  }

  onSelectedCountry = (val, key) => {
    this.setState({ country: val });
    this.setState({ countryName: key });
    if (!this.state.country) {
      this.setState({ countryError: "" });
    }
  };

  onSelectedState = (val, key) => {
    this.setState({ state: val });
    this.setState({ stateAbbr: val });
    if (!this.state.state) {
      this.setState({ stateError: "" });
    }
  };

  onSelectedCity = (val, key) => {
    this.setState({ city: val });
    this.setState({ cityId: key });
    if (!this.state.city) {
      this.setState({ cityError: "" });
    }
  };

  nextStep(e) {
    const err = this.validate();
    if (!err) {
      var data = {
        id: this.state.id,
        userName: this.state.userName.trim(),
        email: this.state.email.trim(),
        firstName: this.state.firstName.trim(),
        lastName: this.state.lastName.trim(),
        dob: this.state.dob.trim(),
        gender: this.state.gender,
        phone: this.state.phone,
        address1: this.state.address1.trim(),
        address2: this.state.address2,
        country: this.state.country,
        countryName: this.state.countryName,
        stateAbbr: this.state.stateAbbr,
        state: this.state.state,
        city: this.state.city,
        cityID: this.state.cityId,
        zipcode: this.state.zipcode,
        password: this.state.password,
        userStatus: this.state.userStatus,
      };
      this.props.saveValues(data);
      this.props.nextStep();
    }
  }

  previousStep(e) {
    e.preventDefault();
    let fieldValues = this.props.saveValues();
    this.props.previousStep();
  }

  render() {
    const previous = "Previous";
    const next = "Next";
    let enableduser = false;
    let enabledemail = false;
    let username = this.props.siteDetails.userName
      ? this.props.siteDetails.userName
      : "";
    if (username.length > 0) {
      enableduser = true;
    }

    let useremail = this.props.siteDetails.email
      ? this.props.siteDetails.email
      : "";
    if (useremail.length > 0) {
      enabledemail = true;
    }

    let phonenoError = this.state.errors ? this.state.errors : [];
    const headerTitle = "Site Admin Details";
    return (
      <div>
        <Panel hasTitle={true} title={headerTitle}>
          {this.state.alert && this.state.alertMessage !== "" && (
            <div className="col-lg-12">
              <Alert
                bsStyle={this.state.msgType}
                onDismiss={this.handleDismiss}
              >
                <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
              </Alert>
            </div>
          )}

          <form role="form" id="StepTwo">
            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="userName">User Name</label>

                <input
                  type="text"
                  className="form-control"
                  name="userName"
                  placeholder="User Name"
                  value={this.state.userName}
                  onChange={this.handlesOnUserChanged}
                  disabled={enableduser}
                  onBlur={this.onUserNameBlur(this.state.userName)}
                  style={{ borderColor: this.state.userNameError }}
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="firstName">First Name</label>

                <input
                  type="firstName"
                  className="form-control"
                  name="firstName"
                  placeholder="First Name"
                  value={this.state.firstName}
                  onChange={this.handlesOnChanged}
                  style={{ borderColor: this.state.firstNameError }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="dob">Date Of Birth</label>

                <input
                  className="form-control"
                  type="date"
                  name="dob"
                  id="exampleInputFile"
                  value={this.state.dob}
                  onChange={this.handlesOnChanged}
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone (format: xxx-xxx-xxxx)</label>

                <NumberFormat
                  format="###-###-####"
                  mask="_"
                  className="form-control"
                  name="phone"
                  placeholder="Phone Number"
                  value={this.state.phone}
                  onChange={this.handlesOnPhoneChanged}
                  style={{ borderColor: this.state.phoneError }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="address1">Address1</label>
                <input
                  type="text"
                  className="form-control"
                  name="address1"
                  placeholder="Address1"
                  value={this.state.address1}
                  onChange={this.handlesOnChanged}
                  style={{ borderColor: this.state.address1Error }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="address2">Address2</label>
                <input
                  type="text"
                  className="form-control"
                  name="address2"
                  placeholder="Address2"
                  value={this.state.address2}
                  onChange={this.handlesOnChanged}
                />
              </div>

              <div className="form-group">
                <label htmlFor="zipcode">Zipcode</label>
                <input
                  type="text"
                  className="form-control"
                  name="zipcode"
                  placeholder="Zipcode"
                  value={this.state.zipcode}
                  onChange={this.handlesOnChanged}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-group">
                <label htmlFor="email">Email</label>

                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Email"
                  value={this.state.email}
                  onChange={this.handlesOnEmailChanged}
                  disabled={enabledemail}
                  onBlur={this.onEmailBlur(this.state.email)}
                  required="required"
                  style={{ borderColor: this.state.emailError }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Last Name</label>

                <input
                  type="text"
                  className="form-control"
                  name="lastName"
                  placeholder="Last Name"
                  value={this.state.lastName}
                  onChange={this.handlesOnChanged}
                  style={{ borderColor: this.state.lastNameError }}
                />
              </div>

              <div className="form-group">
                <label htmlFor="gender">Gender</label>
                <select
                  name="gender"
                  className="form-control"
                  value={this.state.gender}
                  onChange={this.handlesOnChanged}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="form-group">

                <CountryStateCity
                  onSelectedCountry={this.onSelectedCountry}
                  onSelectedState={this.onSelectedState}
                  onSelectedCity={this.onSelectedCity}
                  country={this.state.country}
                  countryName={this.state.countryName}
                  state={this.state.state}
                  stateAbbr={this.state.stateAbbr}
                  city={this.state.city}
                  cityId={this.state.cityId}
                  countryerror={this.state.countryerror}
                  stateerror={this.state.stateerror}
                  cityerror={this.state.cityerror}
                  required="required"
                />
              </div>

              <div className="form-group">
                <label htmlFor="zipcode">Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder="Password"
                  value={this.state.password}
                  onChange={this.handlesOnChanged}
                />
              </div>
            </div>

            <div className="form-footer col-md-12">
              <Button
                bsStyle="success"
                className="btn -default pull-left"
                onClick={this.previousStep}
              >
                Back
              </Button>
              <Button
                bsStyle="info"
                className="btn -primary pull-right"
                onClick={this.nextStep}
              >
                Next
              </Button>
            </div>
          </form>
        </Panel>
      </div>
    );
  }
}

export default StepTwo;



// WEBPACK FOOTER //
// ./src/app/views/manageSite/steps/StepTwo.js